<div class="content" [ngTemplateOutlet]="panelContent">

</div>
